import LocalCookieStorage from '@/service/localCookieStorage';
import Select from '@/components/Form/Select/index.vue';


export default {
  name: 'Header',

  components: {
    Select,
  },

  methods: {
    changeLanguage(selected) {
      this.locale = selected.locale;
      this.$i18n.locale = this.locale;
      LocalCookieStorage.set('current-language', selected.locale);
    },
  },

  data() {
    return {
      input: null,
      locale: this.$i18n.locale,
      isShowDropdown: false,
    };
  },
};
